module.exports = __webpack_public_path__ + "img/dns-active.c5385bf0.png";